import { createContext, useContext, useEffect } from 'react';
export const AsyncValueContext = /*#__PURE__*/createContext(null);
export function useAsyncValue(target, callback) {
  const value = useContext(AsyncValueContext);
  if (!value) {
    throw new Error('useAsyncValue must be used within a AsyncValueProvider');
  }
  const {
    addCallback
  } = value;
  useEffect(() => {
    addCallback(target, callback);
  }, [callback, target, addCallback]);
}
//# sourceMappingURL=field-async-value.js.map